import { ApiConfig } from "../../Config/ApiConfig";
import { CUSTOMERLIST  , CUSTOMERSTATUS  ,  CUSTOMERDETAILS } from "../../Constants/CustomerConstants";
import { createFormDataAction, createGetDataAction, createPostDataAction } from "./CommonAction";



export const CustomerGetAction = (payload:any) => createPostDataAction(CUSTOMERLIST, ApiConfig?.CutomerGetList,payload,false );
export const CustomerStatusAction = (payload:any) => createPostDataAction(CUSTOMERSTATUS, ApiConfig?.CustomerStaus,payload,true );
export const CustomerDetailsAction = (payload:any) => createPostDataAction(CUSTOMERDETAILS, ApiConfig?.CustomerDetails,payload,false );
